"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackCustomExperimentViewed = trackCustomExperimentViewed;

require("core-js/modules/es.array.concat.js");

var _logRocketTrack = require("../../util/logrocket/logRocketTrack");

var _trackingHelper = require("../trackingHelper");

/**
 * @param eventData - Custom experiment viewed event data
 */
function trackCustomExperimentViewed(_ref) {
  var _ref$vendor = _ref.vendor,
      vendor = _ref$vendor === void 0 ? 'ZOLA' : _ref$vendor,
      variationKey = _ref.variationKey,
      experimentName = _ref.experimentName;
  var eventData = {
    vendor: vendor,
    variation_name: variationKey,
    experiment_name: experimentName
  };
  (0, _logRocketTrack.logRocketTrack)("".concat(experimentName, "-").concat(variationKey));
  (0, _trackingHelper.trackEvent)('Custom Experiment Viewed', eventData);
}